module.exports = __webpack_public_path__ + "img/template_w.712e2a25.svg";